export default __webpack_public_path__ + "static/media/Husbandry.429da4ad.svg";